(function () {
    'use strict';
    angular.module('app.giteditor', ['app.nav', 'ui.ace', 'angular-cache', 'app.fileupload', 'rx']);
})();
